export default "__VITE_ASSET__mpBqTAv5__"